<template>
  <div class='controls'>
    <img src='@/assets/images/ui/drag-to-move-black.png' />
    <p>Drag to move</p>
  </div>
</template>

<script>

export default {
};

</script>

<style lang="scss" scoped>

.controls {
  position: absolute;
  user-select: none;
  pointer-events: none;
  width: 240px;
  left: calc(50% - 120px);
  bottom: 80px;

  display: block;
  text-align: center;

  // color: #00939D;
  color: #35383b;

  img {
    width: 240px;
  }

  p {
    margin-top: 24px;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/viewer/DragToMove.vue